var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaturno(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M531.55,466.58c65.94,7.67,120.56,30.67,163.88,69,43.31,38.34,64.98,90.09,64.98,155.25s-28.38,129.58-85.11,186.3c-34.5,34.5-76.09,61.91-124.78,82.23-48.69,20.3-100.62,30.47-155.81,30.47h-5.75v-66.7h5.75c46.75,0,90.27-8.44,130.52-25.3,40.25-16.88,74.56-39.48,102.94-67.86,43.69-43.69,65.55-90.08,65.55-139.14,0-52.12-18.41-91.81-55.2-119.03-36.81-27.22-83.58-40.83-140.3-40.83h-34.5v-228.84h-200.11v-67.84h200.11V34.17h67.84v200.11h200.11v67.84h-200.11v164.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturno);
export default __webpack_public_path__ + "static/media/Saturno.0a4d5117124a6f3271bcd0d23941d91e.svg";
export { ForwardRef as ReactComponent };